import "src/decidim/sw/loader";
import "src/decidim/sw/a2hs";
import "src/decidim/sw/push-permissions";
